export * from "../client/components/headers";

//# sourceMappingURL=headers.js.map